export const menuList = [
  {
    label: 'Wer Wir Sind',
    handle: '/pages/wer-wir-sind',
    style: ' ',
  },
  {
    label: 'Unsure Vision',
    handle: '/pages/unsure-vision',
    style: '',
  },
  {
    label: 'Warum Unser kaschmir',
    handle: '/pages/warum-unser-kaschmir',
    style: '',
  },
  // {
  //   label: 'Verschenken',
  //   handle: '/pages/gift-giving',
  //   style: '',
  // },
];
export const whoList = [
  {
    name: 'Who we are',
    title: 'EINE GEMEINSCHAFT MONGOLISCHER NOMADEN',
    description:
      'Gegründet und aufgebaut von einer Gemeinschaft von Mongolen, kombiniert GOBI Cashmere seit fast 40 Jahren traditionelle Wurzeln und moderne Innovation & Technologie, um Kaschmir von höchster Qualität anzubieten.',
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i1.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: '/',
    style: ' btn-hide',
    gridStyle: ' section-1',
  },
  {
    name: 'Who we are',
    title: 'UNSERE GESCHICHTE',
    description: `GOBI Cashmere bietet das edelste und luxuriöseste Erlebnis Kaschmirs im In- und Ausland. GOBI ist weltweit bekannt für seine speziellen Kaschmirmäntel und ist das einzige Unternehmen, das ausschließlich Kaschmirkleidung mit jahrelanger Leidenschaft und Erfahrung herstellt.`,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i21.jpg?v=1602485603',
    altText: 'Gobi Cashmere',
    handle: '/',
    style: ' btn-hide',
    gridStyle: ' section-2',
  },

  {
    name: 'Who we are',
    title: 'UNSERE HERKUNFT',
    description:
      'Wir bleiben der traditionellen Lebensweise in der heutigen modernen Welt treu. Die Treue unserer nomadischen Herkunft ermöglicht es uns, unseren Kaschmir mit der Welt zu teilen, da es unsere Mitmenschen, unsere Kultur und unsere Lebensweise vereint.',
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i5.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/blogs/kultur/die-hartnackigen-nomaden',
    style: ' btn-show',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: 'NACHHALTIGKEIT',
    description:
      'Als Nomadenkultur und als Mitglied der SFA (Sustainable Fibre Alliance) schätzen wir die Mutternatur, deren Harmonie und Schutz sehr. Wir vertrauen an unsere umweltfreundliche Kaschmirproduktion, dass sie die Lebensgrundlagen von Hirtengemeinschaften erhält und die lebenswichtige Umwelt, in der sie leben, schützt.',
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i6.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/pages/sustainability/',
    style: ' btn-show',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: 'UNTERSTÜTZUNG DES LEBENSUNTERHALTS',
    description:
      'Zur Unterstützung unserer Hirtengemeinschaft liefern wir Kaschmir aus den wilden Steppen der Mongolei direkt vor Ihre Haustür. Dies haben wir durch Abschaffen der Zwischenhändler und Aufbau direkter Verbindungen zu den nomadischen Hirten ermöglicht. Da ihre Kaschmirziegenherde die wertvollste Lebensgrundlage und Vermögen ist.',
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i7.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/blogs/kultur/why-cashmere-is-so-important-to-mongolia',
    style: ' btn-show',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: 'SCHÖPFER DER PERSPEKTIVE',
    description: `Wie wären heute nicht der GOBI, ohne unser Team von über 2.000 Mitarbeitern. Als viertgrößter Arbeitgeber in der Mongolei nehmen wir die Verantwortung, der lokalen Gemeinschaft gleiche Beschäftigungsmöglichkeiten zu bieten.
        Wir sind stolz darauf, dass bei GOBI nicht nur die Chancengleichheit unterstützt wird! Die 75% unserer Belegschaft sind Frauen im Alter von 18 bis 55 Jahren, die sich bis auf Manager- und Führungsebene erstrecken.
        `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i8.jpg?v=1602463991',
    altText: 'Gobi Cashmere',
    handle: '/',
    style: ' btn-hide',
    gridStyle: ' section-125',
  },
];

export const missionList = [
  {
    name: 'Who we are',
    title: 'UNSERE VISION',
    description: `<p>WIR MACHEN KASCHMIR ZUM LIFESTYLE.</p>

     <p>Unser Ziel bei GOBI ist es, die traditionelle Sichtweise von Kaschmir zu stören. Für uns ist Kaschmir nicht nur ein Winterpullover, sondern die beliebteste Alternative für jeden Tag, jede Jahreszeit, jeden Anlass und jedes Alter in allen Lebensbereichen.</p>
     <p>Auf diese Weise bringt GOBI einen Lifestyle von Genuss und Komfort näher, der für jeden zugänglich ist.</p>  
        `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i2.jpg?v=1602463991',
    altText: 'Gobi Cashmere',
    handle: '/',
    style: '',
    gridStyle: ' section-bottom-125',
  },
  {
    name: 'Who we are',
    title: 'UNSERE MISSION',
    description: `<p>TEILEN VON GENUSS UND FREUDE
    </p>

    <p>
    Wir glauben fest daran, dass etwas so Besonderes wie unser Kaschmir nicht nur auf eine kleine Anzahl von Menschen beschränkt sein sollte. Denn jeder verdient, den Genuss und die Freude an 100% mongolischen Kaschmir als kleinen Luxus in seinem Alltag zu erleben.
    </p>

    `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i14.jpg?v=1602463991',
    altText: 'Gobi Cashmere',
    handle: '/',
    style: '',
    gridStyle: ' section-125',
  },
];
export const missionListDesc = [
  {
    title: 'UNSERE WERTSCHÄTZUNG',
    description: `
    <p>
    SPITZENLEISTUNG: Wir übertreffen die Erwartungen, indem wir uns auf das Wesentlichste für uns und unsere Kunden auf die effektivste und effizienteste Weise begehen und konzentrieren.
    </p>
    <p>
    ORIGINALITÄT & LEIDENSCHAFT: Wir verbinden, wer wir sind und unser reiches Kulturerbe mit unserer Leidenschaft, um das zuschaffen, was wir lieben.
    </p>
    <p>
    VERANTWORTUNG: Wir sind bestrebt, gegenüber unseren Mitarbeitern, Kunden und der Gesellschaft verantwortungsbewusst und fair zu handeln.
    </p>
    <p>
    WACHSTUM: Wir sind proaktiv, positiv und nachhaltig in unserer Entwicklung und bemühen uns, unsere Vision zu verwirklichen.
    </p>

    `,
    gridStyle: ' section-125',
  },
  {
    title: 'UNSER VERSPRECHEN',
    description: `
    <p>
    QUALITÄT: Der bequemste Kaschmir der Welt
    </p>
    <p>
    BEWERTUNG: Zu attraktiven Preisen
    </p>
    <p>
    DESIGN: Eine große Auswahl an Designs zum Erkunden
    </p>
    <p>
    NACHHALTIG: Kaschmir, bei dem man sich wohl fühlen kann.
    </p>

    `,
    gridStyle: ' section-125',
  },
];
export const ourCashmereList = [
  {
    name: 'Who we are',
    title: 'KURZFASSUNG',
    description:
      'Der hochwertigste Kaschmir stammt aus dem Geburtsort von GOBI – der Mongolei. Das extreme Wetter und die reichliche Nahrungsmittelversorgung im Land spielen wichtigste Rolle für die Qualität von Kaschmir. Der harte Winter von -40°C und die weiten wilden Steppen der Mongolei erschaffen die perfekte Umgebung für Ziegen, um die längsten und dünnsten Kaschmirfasern anzuwachsen.',
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i3.jpg?v=1602463990',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i3.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/blogs/kultur/das-land-des-weichen-goldes',
    style: ' img2-hide',
    style2: ' btn-show',
    gridStyle: ' section-bottom-125',
  },
  {
    name: 'Who we are',
    title: 'REINER KASCHMIR',
    description: `
    
    Die Produkte von GOBI bestehen aus 100% Kaschmir - denn wir stehen unter der Kontrolle unserer Hirten, des Managements und des härtesten Kritikers von allen, zwar Sie, unsere Kunden.
    
    Das heißt aber nicht, dass alles getan ist. Von Zeit zu Zeit führen wir Mischungen ein, weil der Kaschmir sich mit anderen Fesern gut kombinieren lässt.
   

    `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i13.jpg?v=1602463991',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i3.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/blogs/kultur/konig-der-faser',
    style: ' img2-hide',
    style2: ' btn-show',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: 'FREILAND-ZIEGEN',
    description: `Unsere Geheim-Zutat für den besten Kaschmir der Welt ist ganz einfach, glückliche Ziegen! Die Nomaden in der Mongolei kümmern sich sorgfältig um ihre Ziegenherde wie ihre eigene Familie. Im Laufe der Jahrhunderte stellten wir fest, dass Ziegen im Freien grasen sollten, um kontinuierlich hochwertige Produkte herzustellen, die nirgendwo sonst auf der Welt zu finden sind. 
        `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i11.jpg?v=1602463990',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i3.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/pages/our-production',
    style: ' img2-hide',
    style2: ' btn-show',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: 'ETHISCHES HANDKÄMMEN',
    description: `Unsere Ziegen freuen sich am meisten, wenn der Frühling zu Ende geht. Sie werden traditionell handgekämmt, damit die Ziegen sich von ihrem natürlich abgelösten Kaschmir zu trennen. Kämmen, anstatt zu scheren - der Kaschmir wird sanft entfernt, und die Haut bleibt natürlich unversehrt.

    Diese jahrhundertealte Methode ist ein Zeichen für die natürliche Beziehung zwischen Ziegen und Mutternatur. Sie reguliert die Gesundheit und schützt Ziegen vor Krankheiten und Überhitzung.

        `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Rectangle_730_2.png?v=1602218054',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i3.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/blogs/kultur/why-mongolian-herders-hand-comb-cashmere-and-not-shear',
    style: ' img2-hide',
    style2: ' btn-show',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: 'INHOUSE-PRODUKTION',
    description: `Wir sind stolz auf unsere End-To-End-Kaschmirproduktion in der Mongolei. Vom rohen Kaschmir, über Designer-Entwürfe bis hin zur Weberei und Strickerei werden alles von lokalen Mitarbeitern bei GOBI Inhouse hergestellt. Dies ermöglicht es uns, die Qualität zu versichern, die selbst den höchsten Erwartungen entspricht, und die hohen Kosten der Einzelhändler zu vermeiden.
        `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i10.jpg?v=1602463990',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i3.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: '/',
    style: ' img2-hide',
    style2: ' btn-hide',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: `“MONGOLIAN NOBLE FIBRE”`,
    description: `Jedes Jahr qualifizieren wir uns für die “Mongolian Noble Fibre” (mongolische Edelfaser-Zertifizierung), die aus 100% hochwertigem Kaschmir aus der Mongolei hergestellt werden. Sie stellt sicher, dass GOBI die mongolischen und internationalen Qualitätsstandards für Textilien und Webprodukte erfüllt und den umweltfreundlichen Herstellungsprozess vollständig einhält.
        `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i18.jpg?v=1602463992',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i19.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: '/',
    style: ' img2-show',
    style2: ' btn-hide',
    gridStyle: ' section-bottom-300',
  },
  {
    name: 'Who we are',
    title: `“OEKO-TEX STANDARD 100”`,
    description: `Der “OEKO-TEX STANDARD 100” gehört zu den weltweit bekanntesten Labels für schadstoffgeprüfte Textilien. Alle von “OEKO-TEX STANDARD 100” zertifizierten Produkte, die von angesehenen internationalen Textilinstituten geprüft und zertifiziert wurden, erfüllen ein weltweites Zeichen für verantwortungsvolle Produktion, Sicherheit und Transparenz.
        `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i20.jpg?v=1602463990',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i3.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: '/',
    style: ' img2-hide',
    style2: ' btn-hide',
    gridStyle: ' section-125',
  },
];
export const giftGivingList = [
  {
    name: 'Who we are',
    title: 'FÜR GENUSS UND FREUDE',
    description:
      'GOBI ehrt die Tradition und diejenigen, die unseren Kaschmir genauso genießen wie wir! Unser spezielles Geschenk wurde durch mongolische uralte Sitte inspiriert, und ist ein besonderer Weg Ihnen unsere Kultur und Tradition näher zu bringen.',
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i4.jpg?v=1602463990',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i4.jpg?v=1602463990',
    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/pages/gift',
    style: ' img2-hide',
    style2: ' btn-show',
    gridStyle: ' section-bottom-125',
  },
  {
    name: 'Who we are',
    title: 'KULTUR DES GEBENS',
    description: `Als tief verwurzelte Praxis der Gastfreundschaft ist das mongolische Schenken eine Form der Wertschätzung. Als Nomaden reisen mongolische Familien und lassen sich in abgelegenen Gebieten nieder. Wenn sie einen besonderen Besucher bekommen, ist es immer eine freudige Gelegenheit, gefeiert zu werden. 
    Die Gäste werden mit großartigen Gesprächen und einem kleinen Geschenk verwöhnt, das sie auf ihrer langen Heimreise mit einem warmen, angenehmen Gefühl zum Lächeln bringt.
    `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i12.jpg?v=1602463990',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i4.jpg?v=1602463990',

    altText: 'Gobi Cashmere',
    handle: '/',
    style: ' img2-hide',
    style2: ' btn-hide',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: 'UNSEREN KASCHMIR TEILEN',
    description: `Teilen ist wichtig - was für GOBI nicht wahrer sein könnte. Von handgefertigten Kaschmirsocken bis hin zu gewebten Decken bietet GOBI eine grosse Auswahl an Geschenken für Einkäufe ab einem bestimmten Wert. Einige mögen denken, wir seien zu großzügig, aber wir glauben, dass unsere Kunden mehr wert sind als jeder Gewinn.`,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i15.jpg?v=1602463990',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i4.jpg?v=1602463990',

    altText: 'Gobi Cashmere',
    handle: 'https://www.gobicashmere.com/de/pages/gift',
    style: ' img2-hide',
    style2: ' btn-show',
    gridStyle: ' section-125',
  },
  {
    name: 'Who we are',
    title: 'UNWRITTEN RULE',
    description: `
    Nach den ungeschriebenen Regeln wählen wir bewusst die besten Geschenke aus, die für Ihren Alltag nützlich sind. Daher stellt GOBI unsere Geschenkartikel speziell von Grund auf neu her und verwendet dabei die besten Fasern, die nur in der Mongolei zu finden sind.

    Da dies unser Online-Zuhause ist, hoffen wir, dass unsere Kaschmirgeschenke Ihnen die Freude an warmem Komfort und ein bleibendes Stück unseres nomadischen Kulturerbes hinterlassen.

    `,
    image: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i16.jpg?v=1602463990',
    image2: 'https://cdn.shopify.com/s/files/1/0249/6551/3262/files/i17.jpg?v=1602463991',

    altText: 'Gobi Cashmere',
    handle: '/',
    style: ' img2-show',
    style2: ' btn-hide',
    gridStyle: ' section-bottom-300',
  },
];
